<template>
  <div class="header flex jb">
    <div class='header-back'>
      <div class="refresh-img">
        
      <refreshImg  :duration="6000" imgUrl='index/顶部流光.png''></refreshImg>
      </div>
      <div class="refresh-img">
        
          <refreshImg   stopImg='/' :duration="6000" imgUrl='index/导航右点.png''></refreshImg>
        </div>
        <div class="refresh-img">
        
         <refreshImg     stopImg='/' :duration="6000" imgUrl='index/导航左点.png''></refreshImg>
        </div>
    </div>
    <div class="headerlist flex">
      <div class="headerleft" style="margin-right: 2%;margin-left: 2%;">{{ nowdate }}</div>
      <div class="headerleft" style="margin-right: 2%;">{{ nowtime }} {{ currentTime }}</div>
      <div class="headerleft" style="margin-right: 2%;">{{ tempMax }}℃</div>
      <div class="headerleft" style="margin-right: 2%;">
        <i :class="'qi-' + iconDay"></i>
      </div>
      <div class="headerleft" style="margin-right: 2%;">
        {{ windScaleDay }}
        <!-- <i class="qi-901"></i> -->
      </div>
    </div>
    <div class="headerlist flex ac"
      style="padding-bottom: 0.78vw; gap: 0.63vw;justify-content: center;margin-right: 2rem">
      <img src="../../assets/image/icon3.png" alt />
      <div style="text-align: center;" >
        <p style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: 1.25rem; color: white; margin-bottom: 0.26vw;text-align: left">
          {{ userInfo.currentGenerality.projectShortName }}</p>
        <p
          style=" font-family:PangMenZhengDaoCuShuTi; color: #d9e7ff; font-size: 1rem;text-align: center;">
          铁一样的信念，造就铁一样的精神</p>
      </div>
    </div>
    <div class="headerlist flex" style="padding-right: 1.04vw;justify-content: flex-end">
      <!-- <div class="headerlists" style="font-size: 0.94vw;margin-right: 2%;" @click="isShowClick">
        <div :class="isShow ? 'manbut' : 'manbutzhong'" style="cursor: pointer;">
          <img src="../../assets/image/icon／项目漫游.png" alt
            style="width: 1.25rem; height: 1.25rem;margin-right: .3125rem;" />
          {{ isShow ? '项目漫游' : '取消漫游' }}
        </div>
      </div> -->
      <div class="headerlists" style="font-size: 0.94vw;margin-right: 2%;" @click="addteam">
        <div :class="nonecode == 'none' ? 'manbut' : 'manbutzhong'" style="cursor: pointer;">
          <img src="../../assets/image/预警.png" alt style="width: 1.25rem; height: 1.25rem;margin-right: .3125rem;" />
          消息预警
        </div>
        <!-- <img src="../../assets/image/预警.png" alt="" /> -->
      </div>
      <div class="headerlists" style="font-size: 0.94vw;" @click="toggleUserInfo">
        <div :class="showUserInfo ? 'manbutzhong' : 'manbut'" style="cursor: pointer;">
          <img src="../../assets/image/icon／个人中心.png" alt
            style="width: 1.25rem; height: 1.25rem;margin-right: .3125rem;" />
          个人中心
        </div>
        <!-- <img src="../../assets/image/icon／个人中心.png" alt="" /> -->
        <!-- 弹框 -->
        <div v-show="showUserInfo" class="user-info-popup" @click.stop>
          <div class="user-info-header">
            <img :src="userInfo.avatar" alt
              style=" width: 1.875rem; height: 1.875rem; background: #000; border-radius: 50%;" />
            <div>
              <p style='margin-left:5px;color: rgba(255,255,255,0.9);'>{{ userInfo.nickName }}</p>
              <p style='margin-left:5px; color: rgba(255,255,255,0.55);'>{{ userInfo.postGroup&&userInfo.postGroup.join('|') }}</p>
            </div>
            
          </div>
          <hr />
          <p style="padding: 0 0.2rem; margin-top: 0.15rem; ">
            当前主体
          </p>
          <div style="
            padding: 0 0.2rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.9);
          " class="flex jb ac " @click="openDialog()">
            <div class="generality-title">
              <t-tag theme="warning">{{userInfo.currentGenerality.type}}</t-tag>
              <t-tooltip :content="userInfo.currentGenerality.generalityName">

                <span class="link"> {{ userInfo.currentGenerality.generalityName }}</span>
              </t-tooltip>
            </div>
            <t-icon class="link" name="chevron-right"></t-icon>
          </div>
          <p class="p">所属公司</p>
          <t-tooltip :content='userInfo.deptName'>

            <p style="color: rgba(255,255,255,0.9);font-family: PingFangSC, PingFang SC;font-weight: 600;font-size: .875rem;"
              class="generality-title">
              <strong>{{ userInfo.companyName }}</strong>
            </p>
          </t-tooltip>
          <hr />
          <p class="p">所属部门</p>
          <t-tooltip :content='userInfo.deptName'>

            <p style="font-family: PingFangSC, PingFang SC;font-weight: 600;font-size: .875rem; color: rgba(255,255,255,0.9);"
              class="generality-title">
              <strong>{{ userInfo.deptName }}</strong>
            </p>
          </t-tooltip>
          <hr />
          <p class="p">职务</p>
          <t-tooltip :content="formmatPos(userInfo.postGroup)">
          <p   class="generality-title" style="color: rgba(255,255,255,0.9);font-family: PingFangSC, PingFang SC;font-weight: 600;font-size: .875rem;">
            <strong> {{ formmatPos(userInfo.postGroup) }} </strong>
          </p>
        </t-tooltip>
          <hr />
          <div class="user-info-footer">
            <div class="left" @click="logout">
              <img src="../../assets/image/注销.png" alt style="width: 1rem; height: 1rem;  border-radius: 50%;" />
              <span>注销账号</span>
            </div>
            <div class="vertical-line"></div>
            <div class="right" @click.stop="returnnavi">
              <img src="../../assets/image/返回.png" alt style="width: 1rem; height: 1rem; border-radius: 50%;" />
              <span>返回导航</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <jingbox :nonecode="nonecode" @noneChange="noneChange" />
    <t-dialog attach="app" :visible.sync="showDialog" header='切换主体'  :onConfirm="()=>submitChange()"
    :onClose="()=>showDialog=false">
      <t-row v-for="item in userInfo.generalityList" class="jb" justify="space-between">
        <div class="flex ac dept">
          <t-tag :theme="item.type==='企业'? 'warning':'primary'">{{item.type}}</t-tag>
          <span class="company"> {{ item.deptName }}</span>
        </div>
        <div>
          <div style="display:flex; justify-content: flex-end;">
            <div class="current-tag" v-if="currentDeptId === item.deptId">当前主体</div>
            <t-radio :checked="currentDeptId === item.deptId" allow-uncheck @click="(e) => onClick(e, item)"></t-radio>
          </div>
        </div>
      </t-row>
    </t-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import apngView from "./ApngView.vue";
import refreshImg from "./refreshImg.vue";
export default {
  props: {
    isShow: {
      default: true
    }
    // noshow:{
    //   default:'none'
    // }
  },
  components:{apngView,refreshImg},
  data() {
    return {
      nowdate: "",
      nowtime: "",
      nonecode: "none",
      isShow1: false,
      isShows: this.isShow,
      showUserInfo: false,
      userInfo:{"userId":1,"userName":"admin","nickName":"管理员001","userType":"00","deptId":100,"deptName":"中铁建工集团","companyName":"中铁建工集团","currentGenerality":{"generalityId":581,"generalityName":"蓉南现代农产品流通中心建设项目经理部","type":"项目部"},"postGroup":["董事长"],"generalityList":[{"deptId":101,"deptName":"中铁建工集团第一建设有限公司","type":"企业"},{"deptId":581,"deptName":"蓉南现代农产品流通中心建设项目经理部","type":"项目部"}],"avatar":"http://ztjg-zhgd-dev.oss-cn-shanghai.aliyuncs.com/zhgd/2024.08.02/%E5%A5%B3-1722585613264.png?Expires=3772425613&OSSAccessKeyId=LTAI5tF8i45cPavD6S1tyPfZ&Signature=xhUe%2B0G5hcIE8ZkcZg1hnjVHKBA%3D","phonenumber":"15888888888","sex":1} ,
      windScaleDay: "",
      tempMax: "",
      currentTime: "",
      showDialog: false,
      currentDeptId: ''
    };
  },
  mounted() {
    this.getlist();
    this.timestampToTime();
  },
  created() {
    this.setToken()
    this.getProfile();
  },
  methods: {
    noneChange(e) {
      this.nonecode = e;
    },
    openDialog() {
      this.showDialog = true;
      this.currentDeptId = this.userInfo.currentGenerality.generalityId
    },
    onClick(content, data) {
      if (this.currentDeptId === data.deptId) return;
      this.currentDeptId = data.deptId;
   

    },
    submitChange(){
      if(this.userInfo.currentGenerality.generalityId === this.currentDeptId ) {
        this.$message.warning('当前主体与切换主体一致')
        return
      }

      this.$https.post(this.$url.permissions.generality, { generalityId: this.currentDeptId }).then(res => {
       this.showDialog =false
        this.getProfile();
        this.getlist();
      }).finally(
        ()=>{
          window.location.reload()
          this.$emit('updateUserInfo')
        }

      )
    },
    formmatPos(pos = []) {
      return pos.join('/')
    },
    async getlist() {
      let res = await this.$https.get(this.$url.realname.screen.weather, "");
      if (res?.code == 200) {
        console.log(res.data, 117);
        this.iconDay = res.data[0].iconDay;
        this.windScaleDay = res.data[0].windScaleDay;
        this.tempMax = res.data[0].tempMax;
        this.nowdate = res.data[0].fxDate.replace(/-/g, ".");
        let currentWeekday = new Date().getDay();
        let weekdayNames = [
          "星期日",
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六"
        ];
        let currentWeekdayName = weekdayNames[currentWeekday];
        // this.nowdate = year + "." + month + "." + day
        this.nowtime = currentWeekdayName;
      }
      // requests({
      //   url:this.$url.realname.screen.weather,
      //   method: "get",
      // }).then(res=>{
      //   console.log(res,134);
      //   if(res.code==200){
      //   console.log(res.data,117);
      //   this.iconDay=res.data[0].iconDay
      //   this.windScaleDay=res.data[0].windScaleDay
      // }
      // })
    },
    addteam() {
      if (this.nonecode == "block") {
        this.nonecode = "none";
      } else {
        this.nonecode = "block";
      }
      // this.$emit('isnoShowchange',this.noshow)
    },
    async getProfile() {
      // console.log(this.userInfo);
      let res = await this.$https.get(this.$url.permissions.profile, "");
      console.log(res, 158);
      if (res?.code == 200) {
        // 跳转到首页
        this.userInfo = res.data;
      }
    },
    isShowClick() {
      this.isShows = !this.isShows;
      this.$emit("isShowchange", this.isShows);
    },
    timestampToTime(times) {
      setInterval(() => {
        let time = new Date();
        const hours = time.getHours();
        const minutes = time.getMinutes();
        const seconds = time.getSeconds();

        // 格式化小时、分钟和秒，确保它们始终显示两位数
        const formattedHours = hours < 10 ? "0" + hours : hours;
        const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
        const formattedSeconds = seconds < 10 ? "0" + seconds : seconds;

        this.currentTime = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
      }, 1000); // 更新时间间隔，单位为毫秒
    },
    logout() {
      this.$https.post(this.$url.permissions.logout, {  }).then(res => {
        // 后端接口成功处理
      }).finally(() => {
        // 无论后端接口成功还是失败，都清除本地数据
        Cookies.remove("userInfo");
        Cookies.remove("userToken");
        localStorage.removeItem("userData");
        
        // 跳转到登录页面
        const baseUrl = process.env.VUE_APP_BASE_URL_LOGIN || "";
        location.href = `${baseUrl}/login`;
      })
    },
    returnnavi() {
      const baseUrl = process.env.VUE_APP_BASE_URL_LOGIN || "";
      location.href = `${baseUrl}/html`;
    },
    setToken(){
        const token = this.$route.query.token;
        if (token) {
          Cookies.set('userToken', token);
        }
    },
    toggleUserInfo() {
      console.log("User Info Popup Toggled");
      // Vue.set(this, 'showUserInfo', !this.showUserInfo);
      this.showUserInfo = !this.showUserInfo;
    }
  }
};
</script>
<style lang="scss" >
.t-dialog__ctx .t-dialog{
  padding: 0;
  border:unset;
  .t-dialog__footer{
    padding: 0 24px 16px 24px;
    background: rgba(26,50,83,0.9);
    .t-dialog__cancel{
       background: #23476F;
      border-radius: 4px;
      font-weight: 400;
      font-size: 14px;
      border: unset;
      color: rgba(255,255,255,0.55);
      line-height: 22px;
      text-align: right;
      font-style: normal;
    }
  }
  .t-dialog__header{
    padding: 16px 24px;
    background: #1E3E62;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: rgba(255,255,255,0.9);
    line-height: 24px;
    text-align: left;
    font-style: normal;
    .t-dialog__close{
      color:#fff;
    }
    .t-dialog__header-content{
      font-size: 16px;
    }
  }
  .t-dialog__body{
    padding: 0 24px 16px 24px;
    background: rgba(26,50,83,0.9);
    // box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.5), 0px 2px 36px 0px rgba(0,0,0,0.5), 0px 2px 4px 0px rgba(0,0,0,0.5);
    backdrop-filter: blur(12px);
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(255,255,255,0.9);
    line-height: 22px;
    text-align: left;
    font-style: normal;
    .t-radio__input{
      background:unset ;
      width: 14px;
      height: 14px;
    }
  }
}
</style>
<style lang="scss" scoped>

.header {
  .header-back{
    .refresh-img{
      position: absolute;
    }
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    .apng-div{
      position: absolute;
      top: 0;
    }
  }
  .headerlist {
    z-index: 99;
    img {
      width: 9%;
    }

    .headerlists {
      img {
        width: 1.56vw;
        height: 1.56vw;
      }

      display: flex;
      align-items: flex-end;
      width: 7.5vw;
      height: 100%;
      padding-bottom: 0.73vw;
      font-size: 0.94vw;

      .user-info-popup {
        position: absolute;
        top: 5.6rem;
        right: 0;
        width: 18rem;
        // background: #fff;
       background: rgba(20,48,74,0.6);
        border: 0.0625rem solid rgba(255, 255, 255, 0.3);
        border-radius: 0.3125rem;
        box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1);
        padding: 0.625rem;
        z-index: 10;

        .user-info-header {
          display: flex;
          align-items: center;

          p {
            margin-left: 0.625rem;
            margin: 0;
          }
        }

        hr {
          margin: 0.625rem 0;
          border: 0;
          border-top: 0.0625rem solid rgba(255, 255, 255, 0.3);
        }

        p {
          margin: 0.3125rem 0;
        }

        .p {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.75rem;
          color: rgba(255, 255, 255, 0.55);
        }

        .user-info-footer {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .left,
          .right {
            display: flex;
            align-items: center;

            img {
              margin-right: 0.3125rem;
            }

            span {
              cursor: pointer;
            }
          }

          .vertical-line {
            width: 0.0625rem;
            height: 1.25rem;
            background: #ccc;
          }
        }
      }
      .user-info-popup:hover{
        display: block !important;
      }
      .manbut {
        width: 100%;
        height: 50%;
        background: red;
        font-size: 1.25rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url("../../assets/image/按钮背景-未选中@2x.png") no-repeat;
        background-size: 100% 100%;
        background-position: 0 0;
      }
      .manbut:hover {
        width: 100%;
        height: 50%;
        background: red;
        font-size: 1.25rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url("../../assets/image/按钮背景-未选中@2x(1).png") no-repeat;
        background-size: 100% 100%;
        background-position: 0 0;
      }
      .manbut:hover+.user-info-popup{
        display: block !important;
      }
      .manbutzhong {
        width: 100%;
        height: 50%;
        background: red;
        font-size: 1.25rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url("../../assets/image/按钮背景-未选中@2x(1).png") no-repeat;
        background-size: 100% 100%;
        background-position: 0 0;
      }
    }

    .headerleft {
      display: flex;
      align-items: flex-end;
      height: 100%;
      padding-bottom: 0.73vw;
      font-size: 0.94vw;
    }

    width: 40%;
    height: 100%;
  }

  width: 100%;
  height: 4.69vw;
  min-height: 4.69vw;
  position: relative;
  // background: url("../../assets/image/situation/导航.png") no-repeat;
  background-size: 100% 100%;
  background-position: 0 0;
}

.zhe {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 25, 49, 0.6);
  box-shadow: inset 0px 0px 24px 0px rgba(72, 125, 163, 0.5);
  border: 1px solid rgba(131, 166, 199, 0.3);
  backdrop-filter: blur(16px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;

  .box {
    width: 30rem;
    height: 15.625rem;
    background: rgba(26, 50, 83, 0.9);
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.5), 0px 2px 36px 0px rgba(0, 0, 0, 0.5), 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(12px);

    .head {
      width: 30rem;
      height: 3rem;
      background: #1E3E62;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 .625rem;

      div {
        height: 100%;
        display: flex;
        align-items: center;

        img {
          width: 1.25rem;
          height: 1.25rem;
          margin-right: .3125rem;
        }
      }

      >img {
        width: 1.5625rem;
        height: 1.5625rem;
      }
    }

    .body {
      width: 30rem;
      height: 12.625rem;
      padding: 1.25rem;

      p {
        width: 27.5rem;
        height: 4.125rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: .875rem;
        color: rgba(255, 255, 255, 0.9);
        line-height: 1.375rem;
        text-align: left;
        font-style: normal;
      }

      div {
        width: 27.5rem;
        height: 5.625rem;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;

        button {
          width: 3.75rem;
          height: 2rem;
          background: #23476F;
          color: rgba(255, 255, 255, 0.55);
          border-radius: .25rem;
          border: 0px;
          font-size: .875rem;
        }

        button:hover {
          background: #1074DB;
          color: #fff;
        }
      }
    }
  }
}
.t-row {
  height: 46px;
  // line-height: 0.575rem;
  align-items: center;
  border-bottom: 1px solid rgba(187, 198, 214, 0.15);
  .t-radio {
    margin-left: 20px;
    
  }
 
 
}
.t-row:hover{
  background: #1C416C;
}

.company {
  display: inline-block;
  margin-left: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(255,255,255,0.9);
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-align: left;
  font-style: normal;
  max-width: 200px;
  text-wrap: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.current-tag {
  padding: 0 12px;
  font-size: 12px;
  color: #3595E8;
  background: rgba(16, 116, 219, 0.08);
  border-radius: 12px;
  border: 1px solid #1074DB;
}

.generality-title {
  max-width: 90%;
  text-wrap: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.link {
  color: #007bff
}
</style>
